import { render, staticRenderFns } from "./AccountNew.vue?vue&type=template&id=8cdbdcb2"
import script from "./AccountNew.vue?vue&type=script&lang=js"
export * from "./AccountNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports